<template>
    <div ref="chart" class="completion-bar-container"></div>
</template>

<script>
import * as echarts from 'echarts';

export default {
    name: 'PCompletionBar',
    props: {
        ratio: {
            type: Number,
            required: true,
        },
        completedColor: {
            type: String,
            default: '#4CAF50', // 更现代的绿色
        },
        remainingColor: {
            type: String,
            default: '#E0E0E0', // 更柔和的灰色
        }
    },
    mounted() {
        this.initChart();
    },
    data() {
        return {
            chart: null,
        };
    },
    methods: {
        initChart() {
            this.chart = echarts.init(this.$refs.chart);
            if (this.ratio === null || this.ratio === undefined) {
                // 如果 ratio 未定义，显示空白图表
                this.chart.setOption({
                    tooltip: { show: false },
                    title: {
                        text: 'N/A',
                        left: 'center',
                        top: '30%',
                        textStyle: {
                            fontSize: 18,
                            fontWeight: 'bold',
                            color: '#212121',
                            align: 'center',
                        },
                    },
                    series: []
                });
                return;
            }
            const value = Math.min(100, Math.max(0, this.ratio)); // 限制在 0-100
            const displayText = `${value}%`;

            const option = {
                tooltip: { show: false },
                title: {
                    text: displayText,
                    left: 'center',
                    top: '30%',
                    textStyle: {
                        fontSize: 18,
                        fontWeight: 'bold',
                        color: '#212121',
                        align: 'center',
                    },
                },
                legend: {
                    show: true,
                    bottom: '5%',
                    itemWidth: 14,
                    itemHeight: 8,
                    icon: 'circle',
                    textStyle: {
                        color: '#666'
                    },
                    data: [{ name: '已完成', icon: 'circle' }], // 只显示已完成的图例
                },
                series: [
                    {
                        type: 'pie',
                        center: ['50%', '40%'],
                        radius: ['55%', '65%'],
                        silent: true,
                        hoverAnimation: false,
                        label: { show: false },
                        roundCap: true,
                        data: [
                            {
                                value: value,
                                name: '已完成',
                                itemStyle: {
                                    color: this.completedColor,
                                    borderColor: '#fff',
                                    borderWidth: 2,
                                },
                            },
                            {
                                value: 100 - value,
                                name: '未完成',
                                itemStyle: {
                                    color: this.remainingColor,
                                    borderColor: '#fff',
                                    borderWidth: 2,
                                },
                                label: { show: false },
                                tooltip: { show: false }
                            },
                        ],
                        emphasis: {
                            disabled: true
                        }
                    },
                ],
            };

            this.chart.setOption(option);
        },
    },
    watch: {
        ratio(newVal) {
            if (this.chart) {
                const updatedValue = Math.min(100, Math.max(0, newVal));
                const displayText = `${updatedValue}%`;

                this.chart.setOption({
                    title: {
                        text: displayText
                    },
                    series: [{
                        // 明确提供完整的 data 数组，包含 itemStyle
                        data: [
                            {
                                value: updatedValue,
                                name: '已完成',
                                itemStyle: {
                                    color: this.completedColor, // 使用 props 中的颜色
                                    borderColor: '#fff',
                                    borderWidth: 2,
                                },
                            },
                            {
                                value: 100 - updatedValue,
                                name: '未完成',
                                itemStyle: {
                                    color: this.remainingColor, // 使用 props 中的颜色
                                    borderColor: '#fff',
                                    borderWidth: 2,
                                },
                                label: { show: false },
                                tooltip: { show: false }
                            },
                        ]
                    }]
                });
            }
        }
    },
    beforeUnmount() {
        if (this.chart) {
            this.chart.dispose();
        }
    },
};
</script>

<style scoped>
.completion-bar-container {
    width: 150px;
    height: 155px;
    margin: 0 auto;
}
</style>